export default "__VITE_ASSET__BT1dWbjU__"